import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20soft%20golden%20and%20amber%20light%20rays%20radiating%20from%20center%2C%20film%20grain%20texture%20overlay%2C%20elegant%20movie%20theater%20atmosphere%2C%20subtle%20geometric%20circular%20patterns%20like%20film%20reels%2C%20warm%20peach%20and%20cream%20gradient%20background%2C%20artistic%20cinematography%20style%2C%20soft%20bokeh%20lights%20floating%2C%20clean%20minimalist%20aesthetic%2C%20dark%20silhouette%20of%20cinema%20seats%20at%20bottom%20edge&width=1600&height=900&seq=mitao-hero-01&orientation=landscape"
        alt="蜜桃电影 - 精选好片在线观看推荐"
        title="蜜桃电影"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
          发现你的下一部
          <span className="text-primary-400">挚爱电影</span>
        </h1>
        <p className="text-white/80 text-sm md:text-lg max-w-2xl leading-relaxed">
          蜜桃电影为您精选海量优质影片资源，涵盖爱情、喜剧、动作、悬疑等多种类型，
          高清在线观看体验流畅，立即探索热门推荐片单，开启精彩观影之旅
        </p>
        <div className="flex items-center gap-3 mt-6 md:mt-8 flex-wrap justify-center">
          <Link
            to="/category/aiqing"
            className="px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            探索分类
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-semibold hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}